import { useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import UploadImages from "./upload-images";
import { styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const AddImage: React.FunctionComponent<{ onAddImages: any }> = (props) => {

    const [openPopUp, setOpenPopUp] = useState<boolean>(false);
    const [isUploaded, setIsUploaded] = useState<boolean>(false);
    const { t } = useTranslation();

    const handleCloseDialog = () => {
        setOpenPopUp(false);
    };

    const AddImage = () => {
        setOpenPopUp(true);
    }

    const UploadImagesHandler = (obj: any, value: boolean) => {
        setOpenPopUp(false);
        setIsUploaded(true)
        props.onAddImages(obj, value).then(() => {
            setIsUploaded(false)
        }).catch(() => {
            setIsUploaded(false)
        })
    }

    return (

        <>
            <button type="submit" className="button-reset back-746AFF color-FFFFFF border-746AFF padd-15" onClick={AddImage}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_23_299)">
                        <path d="M8 3.33334V12.6667" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M3.33203 8H12.6654" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_23_299">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <div className="display-none-mb">{t("listingCreation.addImages")}</div>
                {isUploaded && <div className="col-auto marg-left-5">
                    <div className="spinner-border text-white size-20" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}
            </button>

            <BootstrapDialog
                open={openPopUp}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle>
                    <div className="title-24">{t("listingCreation.addImages")}</div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <div className="padd-20">
                        <UploadImages OnUploadImages={UploadImagesHandler} name={t(`listingCreation.Upload Your Images`)} />
                    </div>
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}

export default AddImage;